import { message } from "antd";
import Axios from "axios";
import { useDispatch } from "react-redux";
// import { useNavigate } from "react-router-dom";
 
 
const base_Url = process.env.REACT_APP_BASE_URL ;
// const base_Url = "http://localhost:7089";


    
export function getOtp(values) {
  //.log("valuesvalues", values);
  let body = {
    First_Name: values.firstName,
    Mobile: values.mobileNo,
    Email: values.email,
    verifyMode: "Email",
  };
  
  //.log("body signup", body);
  return new Promise((res, rej) => {
    Axios.post(`${base_Url}/user/getOtpForVerification`, body)
      .then((response) => {
        res(response.data);
      })
      .catch((error) => {
        // notification.error(error);
        //.log("error", error);
      });
  });
}
export function getOtpContractFarming(values) {
  //.log("valuesvalues", values);
  let body = {
    First_Name: values.firstName,
    Mobile: values.mobileNo,
    Email: values.email,
  
  };
  
  //.log("body signup", body);
  return new Promise((res, rej) => {
    Axios.post(`${base_Url}/contract_farming/getOtpForVerification`, body)
      .then((response) => {
        res(response.data);
      })
      .catch((error) => {
        // notification.error(error);
        //.log("error", error);
      });
  });
}
export function getOtpforResendinSignup(values) {
  //.log("valuesvalues", values);
  let body = {
    First_Name: values.firstName,
    Mobile: values.mobileNo,
    Email: values.email,
    RefId:values.tr,
 
    verifyMode: "Email",
  };
  //.log("body signup", body);
  return new Promise((res, rej) => {
    Axios.post(`${base_Url}/user/getOtpForVerification`, body)
      .then((response) => {
        res(response.data);
      })
      .catch((error) => {
        // notification.error(error);
        //.log("error", error);
      });
  });
}
export function getOtpforResendinlogin(values) {
  //.log("valuesvalues", values);
  let body = {
    UserName: values.UserName,
    password: values. password,
    userType: values.userType,
    RefId:values.refId,
 
   
  };
  //.log("body signup", body);
  return new Promise((res, rej) => {
    Axios.post(`${base_Url}/user/login`, body)
      .then((response) => {
        res(response.data);
      })
      .catch((error) => {
        // notification.error(error);
        //.log("error", error);
      });
  });
}
 
export function verifyOtpAndSignUp(values) {
//   const location = useLocation();
//  let {  selectedURL } = location.state;
  //.log("valuesvalues", values);
  let body = {
    First_Name: values.firstName,
    Middle_Name: values.middleName,
    Last_Name: values.lastName,
    Mobile: values.mobileNo,
    Email: values.email,
    Password: values.password,
    userType: values.User_type==="GCA"?"General Commission Agent":values.User_type,
    enteredOTP: values.enteredOTP,
    RefId:values.tr
  };
  //.log("body signup", body);
  return new Promise((res, rej) => {
    Axios.post(`${base_Url}/user/userRegister`, body)
      .then((response) => {
        res(response.data);
      })
      .catch((error) => {
        let errorMessage = "An unknown error occurred.";
 
        if (error.response && error.response.data) {
          errorMessage = error.response.data.message || errorMessage;
        }
 
        // alert(errorMessage);
        rej(error);
      });
  });
 
 
 
}
export function verifyOtpAndSignUpContractFarming(values) {
//   const location = useLocation();
//  let {  selectedURL } = location.state;
  //.log("valuesvalues", values);
  let body = {
    First_Name: values.firstName,
    Middle_Name: values.middleName,
    Last_Name: values.lastName,
    Mobile: values.mobileNo,
    Email: values.email,
    Password: values.password,
    userType: values.User_type,
    enteredOTP: values.enteredOTP,
    Gender:values.gender,
    Organisations:values.organisation
    // RefId:values.tr
  };
  //.log("body signup", body);
  return new Promise((res, rej) => {
    Axios.post(`${base_Url}/contract_farming/userRegister`, body)
      .then((response) => {
        res(response.data);
      })
      .catch((error) => {
        let errorMessage = "An unknown error occurred.";
 
        if (error.response && error.response.data) {
          errorMessage = error.response.data.message || errorMessage;
        }
 
        // alert(errorMessage);
        rej(error);
      });
  });
 
 
 
}
 
export function login(body) {

  return new Promise((res, rej) => {
  

    Axios.post(`${base_Url}/user/login`, body)
      .then((response) => {
        res(response.data);
      })
      .catch((error) => {
        //.log("error", error);
      });
  });
}
export function loginContractFarming(body) {

  return new Promise((res, rej) => {
  

    Axios.post(`${base_Url}/contract_farming/login`, body)
      .then((response) => {
        res(response.data);
      })
      .catch((error) => {
        //.log("error", error);
      });
  });
}
 
export function verifyLogin(values) {
  
  let body = {
    UserName: values.UserName,
    enteredOTP: values.enteredOTP,
    password: values.password,
    RefId:values.pr,
  };
  //.log("body login", body);
  return new Promise((res, rej) => {
    Axios.post(`${base_Url}/user/verify-login`, body)
      .then((response) => {
        res(response.data);
      })
      .catch((error) => {
        let errorMessage = "An unknown error occurred.";
 
        if (error.response && error.response.data) {
          errorMessage = error.response.data.message || errorMessage;
        }
 
        // alert(errorMessage);
        rej(error);
      });
  });
}
 
 
export function getOtpForForgotPassword(values) {
  //.log("valuesvalues", values);
 
  const isTraderOrPanel = values.role === "Trader_Login" || values.role === "Panel_Engineer_Login" || values.role === "GCA_Login" ||values.role==="Sponsor_Login";
 
  let body = isTraderOrPanel
    ? {
        Mobile: values.mobileNo || values.mobile,
        Email: values.email,
      }
    : {
        Mobile: values.mobileNo || values.mobile,
        Email: values.email,
        UserName: values.username,
        Key: values.key,
      };
 
  //.log("ForgotPassword Payload", body);
 
  return new Promise((res, rej) => {
    Axios.post(`${base_Url}/user/forgotPassword-getotp`, body)
      .then((response) => {
        res(response.data);
      })
      .catch((error) => {
        //.log("error", error);
        rej(error);
      });
  });
}
 
export function getOtpForForgotPasswordResend(values) {
  //.log("valuesvalues", values);
 
  const isTraderOrPanel = values.role === "Trader_Login" || values.role === "Panel_Engineer_Login" || values.role === "GCA_Login";
 
  let body = isTraderOrPanel
    ? {
        Mobile: values.mobileNo || values.mobile,
        Email: values.email,
        RefId:values.RefId
      }
    : {
        Mobile: values.mobileNo || values.mobile,
        Email: values.email,
        UserName: values.username,
        Key: values.key,
        RefId:values.RefId
      };
 
  //.log("ForgotPassword Payload", body);
 
  return new Promise((res, rej) => {
    Axios.post(`${base_Url}/user/forgotPassword-getotp`, body)
      .then((response) => {
        res(response.data);
      })
      .catch((error) => {
        //.log("error", error);
        rej(error);
      });
  });
}
 
 
 
export function verifyOtpForForgotPassword(values) {
  //.log("Received Values:", values);
 
  const isTraderOrPanel = values.role === "Trader_Login" || values.role === "Panel_Engineer_Login" || values.role === "GCA_Login";
 
  let body = isTraderOrPanel
    ? {
        Mobile: values.mobileNo || values.mobile,
        Email: values.email,
        Password: values.Password,
        enteredOTP: values.enteredOTP,
        RefId: values.RefId,
       
      }
    : {
        Mobile: values.mobileNo || values.mobile,
        Email: values.email,
        UserName: values.username,
        Key: values.key,
        Password: values.Password,
        enteredOTP: values.enteredOTP,
        RefId: values.RefId,
       
      };
 
  //.log("ForgotPassword Payload", body);
 
  return new Promise((res, rej) => {
    Axios.post(`${base_Url}/user/forgotPassword-varifyotp`, body)
      .then((response) => {
        res(response.data)
       
      })
      .catch((error) => {
        //.log("error", error);
        rej(error);
      });
  });
}
 
 